import { gql, useMutation } from '@apollo/client'

export const UPDATE_FEED = gql`
  mutation ($input: FeedUpdate) {
    updateFeed(input: $input) {
      argument_type
      author_id
      body
      body_updated_at
      campaign_id
      created_at
      id
      properties
      gallery
      __typename
    }
  }
`

export const useUpdateFeed = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_FEED, {
    update(cache) {
      cache.modify({
        fields: {
          getFeeds() {},
          getFeedsByCampaignId() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
